import { render, staticRenderFns } from "./DishHelp.vue?vue&type=template&id=b2ae1186&"
import script from "./DishHelp.vue?vue&type=script&lang=js&"
export * from "./DishHelp.vue?vue&type=script&lang=js&"
import style0 from "./DishHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports